import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

const Header = () => {
  const location = useLocation();

  const [header, setHeader] = useState(
    "navbar navbar-expand-lg bg-transparent"
  );

  const listenScrollEvent = (event) => {
    if (window.scrollY < 50) {
      return setHeader("navbar navbar-expand-lg bg-transparent");
    } else if (window.scrollY > 46) {
      return setHeader("navbar navbar-expand-lg minav-dark");
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);

    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);
  return (
    // TODO togglear el color del navbar al presionar en el menu respondive!!!!
    !location.pathname.includes("/watch") && (
      <Navbar
        collapseOnSelect
        bg="dark"
        variant="dark"
        expand="lg"
        className={header}
      >
        <Link className="Link" to="/" onClick={() => window.scrollTo(0, 0)}>
          <Navbar.Brand className="navbar-brand logo fs-3  fw-bold  ms-3">
            <span className="fw-light">Hack</span>Flix
          </Navbar.Brand>
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav " />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto nav-content d-flex align-items-center ">
            {/* Mobile------------------------------------- */}
            <div className="navResponsive">
              <Nav.Link href="#">
                <Link
                  className="Link my-2 fw-bold fs-5"
                  to="/"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <Nav.Item className="navItem">Home</Nav.Item>
                </Link>
              </Nav.Link>

              <Nav.Link href="#">
                <Link
                  className="Link my-2 fw-bold fs-5"
                  to="/showall"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <Nav.Item className="navItem">All movies</Nav.Item>
                </Link>
              </Nav.Link>

              <Nav.Link href="#">
                <Link
                  className="Link my-2 fw-bold fs-5"
                  to="/about"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <Nav.Item className="navItem">About us</Nav.Item>
                </Link>
              </Nav.Link>

              <Nav.Link href="#">
                <Link
                  className="Link my-2 fw-bold fs-5"
                  to="/contact"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <Nav.Item className="navItem">Contact</Nav.Item>
                </Link>
              </Nav.Link>

              <NavDropdown
                className="navItem navDrop my-2 fw-bold fs-4 text-white"
                title="Search by"
                id="basic-nav-dropdown"
                menuVariant="dark"
              >
                <Link
                  className="Link"
                  to="/search/title"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <NavDropdown.Item
                    href="#action/3.1"
                    className="navItem dropItem"
                  >
                    Search by title
                  </NavDropdown.Item>
                </Link>
                <Link
                  className="Link"
                  to="/search/rating"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <NavDropdown.Item
                    href="#action/3.2"
                    className="navItem dropItem"
                  >
                    Search by ratign
                  </NavDropdown.Item>
                </Link>
              </NavDropdown>
            </div>

            {/* desk------------------------------------- */}
            <NavDropdown
              className="navItem navItemDesk navDrop me-1"
              title="Search by"
              id="basic-nav-dropdown"
              menuVariant="dark"
            >
              <Link
                className="Link"
                to="/search/title"
                onClick={() => window.scrollTo(0, 0)}
              >
                <NavDropdown.Item
                  href="#action/3.1"
                  className="navItem navItemDesk dropItem"
                >
                  Search by title
                </NavDropdown.Item>
              </Link>
              <Link
                className="Link"
                to="/search/rating"
                onClick={() => window.scrollTo(0, 0)}
              >
                <NavDropdown.Item
                  href="#action/3.2"
                  className="navItem navItemDesk dropItem"
                >
                  Search by ratign
                </NavDropdown.Item>
              </Link>
            </NavDropdown>
            <Link className="Link" to="/" onClick={() => window.scrollTo(0, 0)}>
              <Nav.Item className="navItem navItemDesk">Home</Nav.Item>
            </Link>

            <Link
              className="Link"
              to="/showall"
              onClick={() => window.scrollTo(0, 0)}
            >
              <Nav.Item className="navItem navItemDesk">All movies</Nav.Item>
            </Link>

            <Link
              className="Link"
              to="/about"
              onClick={() => window.scrollTo(0, 0)}
            >
              <Nav.Item className="navItem navItemDesk">About us</Nav.Item>
            </Link>
            <Link
              className="Link"
              to="/contact"
              onClick={() => window.scrollTo(0, 0)}
            >
              <Nav.Item className="navItem navItemDesk">Contact</Nav.Item>
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  );
};

export default Header;
